import { useNavigate } from "react-router-dom";
import "../../../styles/components/home/categories/homeCategoryCardComponent.scss";

export const HomeCategoryCardComponent = ({ category }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/categories/${category.id}`);
  };

  return (
    <div className="homeCategoryCardContainer" onClick={handleClick}>
      <div className="imageContainer">
        <img src={category.imageURL} alt={category.name} />
      </div>
      <div className="detailsContainer">
        <h3>{category.categoryName}</h3>
      </div>
    </div>
  );
};

export default HomeCategoryCardComponent;
